export const AlphaModes = [
    "OPAQUE",
    "MASK",
    "BLEND"
];
